module.exports = __webpack_public_path__ + "assets/img/banner5.1da8b938.png";